export const webview = {
  webviewContent: 'Este es un URL externo y se abrirá en una nueva ventana. ¿Abrir?',
  webviewButtonOpenTitle: 'Abrir',
  webviewButtonCopyTitle: 'Copiar URL',
  webviewButtonOpenAgainTitle: 'Abrir de nuevo',
  notifications: {
    urlCopied: '¡URL copiado!'
  }
}
